import { PinPath, Point } from '../Types';

function wrapIndex(index: number, length: number): number {
  const wrapped = index % length;
  return wrapped < 0 ? wrapped + length : wrapped;
}

export function resolveSegmentEndpoints(points: Point[], path: PinPath): Array<[Point, Point]> {
  const segments: Array<[Point, Point]> = [];
  if (points.length === 0 || path.pinIndices.length < 2) {
    return segments;
  }

  const segmentCount = Math.min(path.pinIndices.length - 1, path.exitDeltas.length);
  for (let i = 0; i < segmentCount; i++) {
    const fromPin = path.pinIndices[i];
    const toPin = path.pinIndices[i + 1];
    const delta = path.exitDeltas[i];
    const fromIndex = wrapIndex(fromPin + delta, points.length);
    const toIndex = wrapIndex(toPin, points.length);
    segments.push([points[fromIndex], points[toIndex]]);
  }

  return segments;
}
